
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAssociatedTargetAisIec as ObiAssociatedTargetAisIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-associated-target-ais-iec.js';
 
 
 

 
 export const ObiAssociatedTargetAisIec = createComponent({
   react: React,
   tagName: 'obi-associated-target-ais-iec',
   elementClass: ObiAssociatedTargetAisIecElement,
   events: {
     
   }
  });
 
 